<div class="px-28 mb-10 flex justify-around">
  <a
    (click)="downloadPdf()"
    class="
      uppercase
      inline-flex
      items-center
      px-3
      py-2
      cursor-pointer
      border border-transparent
      shadow-sm
      text-sm
      leading-4
      font-medium
      rounded-md
      text-white
      bg-orange-forbes
      focus:outline-none
      focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
    "
    download="eac.pdf"
  >
    download pdf
    <svg
      class="ml-2 -mr-0.5 h-4 w-4"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
      ></path>
    </svg>
  </a>
</div>
<div class="pb-5">
  <pdf-viewer
    [src]="pdfSrc"
    [show-all]="true"
    [render-text]="true"
    style="display: block; height: 100vh; margin-bottom: 20px"
  ></pdf-viewer>
</div>
